<template>
    <!-- 右边主体[[ -->
    <div>
        <div class="g-tab">
            <router-link class="g-tab-item" active-class="g-tab-item-active" :to="{name: 'v4-order-personal'}">个人订单</router-link>
            <router-link class="g-tab-item" active-class="g-tab-item-active" :to="getRoutePath">
                供应商派单
            </router-link>
        </div>
        <router-view></router-view>
    </div>

    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
    @import  '~Assets/sass/pages/v4/order/order.scss';
</style>
<script>
import {
    SupplierIdentity 
} from 'Services/getData.js';
export default {
    name: 'order.vue',
    data() {
        return {
            userType: 1 // 1:当前用户为供应商,2:当前用户为订单接收人或关联人，3：不参与供应商派单
        }
    },
    created() {
	        this.getSupplierIdentity();
    },
    methods: {
	        async getSupplierIdentity() {
		        let res = await SupplierIdentity();
		        if(res.data && res.data.code === 0){
			        this.userType = res.data.data.userType;
            }
	        }
    },
    computed: {
        getRoutePath() {
            if(this.userType == 1){
                return {
                    name: 'v4-order-demand' 
                };
            }else if(this.userType == 2){   // 作者
                return {
                    name: 'v4-order-author-order-list' 
                };
            }else{
                return {
                    name: 'v4-order-supplier' 
                }
            }


        }
    }
}
</script>

